var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide"},[_c('img',{staticClass:"p-4",attrs:{"src":'/uploads/companys/'+_vm.src,"height":"100","width":"200","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }